import { render, staticRenderFns } from "./KultunautCard.vue?vue&type=template&id=30cc6423&"
import script from "./KultunautCard.vue?vue&type=script&lang=js&"
export * from "./KultunautCard.vue?vue&type=script&lang=js&"
import style0 from "./KultunautCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports